<div class="top-nav-bar">
  <div class="top-main-nav">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="logo">
          <a routerLink="/documentation/intro">
            <img alt="" src="./assets/MAD_logo.png" width="25" height="25" />
            Project title
          </a>
        </div>

        <button mat-button [matMenuTriggerFor]="layouts" class="drop-down">Layouts</button>
        <mat-menu #layouts="matMenu">
          <button mat-menu-item routerLink="base-page-layout">Base Pagelayout</button>
          <button mat-menu-item routerLink="flowbar-page-layout">Flowbar Layout</button>
          <button mat-menu-item routerLink="sidebar-page-layout">Sidebar Layout</button>
          <button mat-menu-item routerLink="advanced-sidebar-page-layout">Advanced Sidebar Layout</button>
          <button mat-menu-item routerLink="advanced-sidebar-with-default-header-page-layout">
            Advanced Sidebar Layout With Default Header
          </button>
        </mat-menu>

        <div class="flex-spacer"></div>

        <button mat-button>
          <mat-icon class="material-icons-outlined" color="primary">notifications</mat-icon>
        </button>
        <button mat-button [matMenuTriggerFor]="applicationSwitch" class="drop-down">
          <mat-icon color="primary">apps</mat-icon>
        </button>
        <mat-menu #applicationSwitch="matMenu" xPosition="before">
          <button mat-menu-item>Application 1</button>
          <button mat-menu-item>Application 2</button>
          <button mat-menu-item class="current-page">Application 3</button>
        </mat-menu>
        <button mat-button [matMenuTriggerFor]="accountMenu" class="drop-down">
          <mat-icon class="material-icons-outlined" color="primary">account_circle</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu">
          <button mat-menu-item>User Settings</button>
          <button mat-menu-item>Logout</button>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
</div>

<router-outlet></router-outlet>
